"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchRecommendationApiCall = fetchRecommendationApiCall;
exports.watchRecommendation = watchRecommendation;
var _effects = require("redux-saga/effects");
var _recommendationActions = require("./recommendationActions");
var _userSelectors = require("../user/userSelectors");
var _errorSelectors = require("../error/errorSelectors");
var _errorActions = require("../error/errorActions");
var _constants = require("../../utils/constants");
var _userActions = require("../user/userActions");
var _services = require("../../services");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
function* fetchRecommendationApiCall(instanceId) {
  const marketingId = yield (0, _effects.select)((0, _userSelectors.selectMarketingId)(instanceId));
  const url = `${_constants.API_PATH.GS_JOURNEY}/recommendation/v4/queryProductRecommendation?filter=marketingId==${marketingId}`;
  return yield (0, _effects.call)(_services.http.get, url);
}
function* fetchRecommendation(action) {
  try {
    const data = yield fetchRecommendationApiCall(action.instanceId);
    yield (0, _effects.put)({
      ...(0, _recommendationActions.setRawRecommendation)(data),
      instanceId: action.instanceId
    });
    yield (0, _effects.put)({
      type: _recommendationActions.FETCH_RECOMMENDATION_SUCCESS,
      instanceId: action.instanceId
    });
    yield (0, _effects.put)({
      ...(0, _questionnaireActions.adjustBudget)(false),
      instanceId: action.instanceId
    });
  } catch (e) {
    console.log(e);
    const currentPage = yield (0, _effects.select)((0, _errorSelectors.selectCurrentPage)(action.instanceId));
    yield (0, _effects.put)({
      ...(0, _errorActions.setApiCallError)({
        errorMessage: 'We were not able to generate your recommendations. Please try again.',
        actionToRetry: action,
        pageToReturnTo: currentPage
      }),
      instanceId: action.instanceId
    });
  }
}
function* fetchRecommendationSuccess(action) {
  yield (0, _effects.put)({
    type: _userActions.SAVE_USER_SESSION,
    payload: {
      nextQuestionIndex: _constants.RECOMMENDATION_PAGE_INDEX
    },
    instanceId: action.instanceId
  });
}
function* watchRecommendation() {
  yield (0, _effects.takeEvery)(_recommendationActions.FETCH_RECOMMENDATION, fetchRecommendation);
  yield (0, _effects.takeEvery)(_recommendationActions.FETCH_RECOMMENDATION_SUCCESS, fetchRecommendationSuccess);
}